import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import Modal from '@/components/modalBase/modalBase'
import { Getter, Action, Mutation } from 'vuex-class'
import { VueTelInput } from 'vue-tel-input'
import Loading from '@/components/loading/loading'
import Multiselect from '@/components/multiselect/multiselect'

@Component({
  components: {
    Modal,
    Loading,
    VueTelInput,
    Multiselect
  }
})
export default class ModalAddress extends Vue {
  @Prop({ default: false }) show!: Boolean

  // Getters
  @Getter getCity
  @Getter getUser
  @Getter getIsUnderMobile
  @Getter getCurrentAddress
  @Getter getIsOnDemandValid;
  @Getter getCurrentCityZone;

  // Actions
  @Action action_queryAddress;
  @Action action_queryAddressByCoordinates;
  @Action action_createAddress;
  @Action action_deleteAddress;
  @Action action_getUser;
  @Action action_isOnDemandValid;

  // Mutations
  @Mutation CURRENT_ADDRESS
  @Mutation CURRENT_CITY_ZONE

  searchAddress = ""

  zone = ''
  queryAddress = ''
  showMap = false;
  showErrors = false;
  errors = []
  loadingQuery = false;


  mapOptions = {
    center: { lat: 4.70, lng: -74.05 },
    zoom: 16,
    fullscreenControl: false,
    mapTypeControl: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    zoomControl: false
  }


  markerOptions = {
    position: { lat: 4.701, lng: -74.05 },
    title: 'Marker A',
    draggable: true
  }

  positionMarker = { lat: 4.70, lng: -74.05 }
  googleResultAddress = ''
  googleResultAddressExtra = ''
  nameAddress = ''

  temporalLatGoogle = 0
  temporalLngGoogle = 0

  selectedAddress = {}

  googleQueryResults = {}

  locationExample = {}
  queryLoading = true
  hasToAddAddress = false

  errorMessage = ''

  isAddingNewAddress = false;

  showSuggestions = false;

  isCreatingAddress = false;
  isDeletingAddress = false;
  isManualSetup = false;

  setZone(value) {
    if(value) {
      this.zone = value;
    }
  }

  get getActiveZones() {
    let response = [];
    if(this.getCity && this.getCity.zones && this.getCity.zones.length) {
      response = this.getCity.zones.filter((zone) => zone.is_active);
    }
    return response;
  }

  get getAddressSuggestions() {
    let response = [];
    if(this.googleAddresses && this.googleAddresses.length) {
      let maxItems = 3;
      for(let i=0; i < this.googleAddresses.length && i < maxItems; i++) {
        response.push(this.googleAddresses[i]);
      }
    }
    return response;
  }

  mounted() {
    if(!this.getCurrentAddress) {
      this.isAddingNewAddress = true;
    }
    this.isDeletingAddress = false;
  }

  @Watch('hasToAddAddress')
  onAddingAddress() {
    if(this.getCity && this.getCity.zones) {
      let selectedZone = this.getCity.zones.find((item) => item.name === 'Bogota');
      if(!selectedZone) {
        for(let i=0; i < this.getCity.zones.length && !selectedZone; i++) {
          if(this.getCity.zones[i].is_active) {
            selectedZone = this.getCity.zones[i];
          }
        }
      }
      this.zone = selectedZone;
    }
  }

  @Watch('zone')
  setErrorMessage() {
    if (this.zone) {
      this.errorMessage = '';
      this.queryAddress = '';
    }
  }

  isCurrentAddress(address) {
    let response = false;
    if (
      address &&
      address.id &&
      this.getCurrentAddress &&
      this.getCurrentAddress.id &&
      this.getCurrentAddress.id == address.id
    ) {
      response = true;
    }
    return response;
  }

  async _queryAddresCoordinates() {
    this.queryLoading = false;
    return new Promise((resolve) => {
      setTimeout(async () => {
        const resp = await this.action_queryAddressByCoordinates(
          `${(this.positionMarker as any).lat},${(this.positionMarker as any).lng}`
        );
        this.googleResultAddress =
          resp && resp.results && resp.results[0].formatted_address.split(",")[0];
        this.queryLoading = true;
        this.queryAddress = this.googleResultAddress;

        // resolve();
      }, 200);
    });
  }

  get getAvailableZones() {
    const sortFunction = (a, b) => {
      if(a.name < b.name) return -1;
      if(a.name > b.name) return 1;
      return 0;
    };
    if(this.getCity && this.getCity.zones) {
      return this.getCity.zones.filter((zone) => zone.is_active).sort(sortFunction);
    }
    return [];
  }

  get getHasAddresses() {
    return (
      Object.keys(this.getUser).length &&
      this.getUser.addresses &&
      this.getUser.addresses.length > 0
    );
  }

  get googleAddresses() {
    return this.googleQueryResults && (this.googleQueryResults as any).results
  }

  getCityName(name) {
    const array = name && name.split(',');
    return array[array.length - 2];
  }

  async updatePosition(pos) {
    this.loadingQuery = true;
    if (pos && pos.latLng) {
      const newPos = {
        lat:  pos.latLng.lat(),
        lng: pos.latLng.lng()
      }
      this.positionMarker = newPos;
      this.temporalLatGoogle = newPos.lat;
      this.temporalLngGoogle = newPos.lng;
      const errorIndex = this.errors.findIndex((item) => item === 'no_coordinates');
      if(errorIndex >= 0) {
        this.errors.splice(errorIndex, 1);
      }
      if(!this.isManualSetup) {
        await this._queryAddresCoordinates();
      }
    }
    this.showSuggestions = false;
    this.loadingQuery = false;
  }

  checkZone() {
    if (!this.zone) {
      this.errorMessage = 'Tienes que seleccionar primero una zona';
      return false;
    }
    return true;
  }

  selectAddressToMap(address) {
    if (!this.checkZone()) {
      return;
    }
    this.errorMessage = '';
    this.temporalLatGoogle = address.geometry.location.lat;
    this.temporalLngGoogle = address.geometry.location.lng;
    this.markerOptions.position = { lat: this.temporalLatGoogle, lng: this.temporalLngGoogle }
    this.mapOptions.center = { lat: this.temporalLatGoogle, lng: this.temporalLngGoogle }
    this.showMap = true;
    this.googleResultAddress = address.formatted_address
    this.queryAddress = address.formatted_address;
    this.positionMarker = {
      lat: this.temporalLatGoogle,
      lng: this.temporalLngGoogle
    }
    this.showSuggestions = false;
  }

  getErrors(error_name) {
    return this.showErrors && this.errors.includes(error_name)
  }

  getLocation() {
    if (!this.checkZone()) {
      return;
    }
    this.errorMessage = "";
    if (navigator.geolocation)
      navigator.geolocation.getCurrentPosition(this.setLocation, this.locationError);
    else alert("Geolocation is not supported by this browser.");
  }

  setLocation(pos) {
    this.mapOptions = {
      ...this.mapOptions,
      center: { lat: pos.coords.latitude, lng: pos.coords.longitude }
    };
    // this.center = { lat: pos.coords.latitude, lng: pos.coords.longitude }
    this.markerOptions.position = { lat: pos.coords.latitude, lng: pos.coords.longitude };
    this.showMap = true;
  }

  async checkAddress() {
    this.showSuggestions = true;
    this.loadingQuery = true;
    if (!this.checkZone()) {
      this.queryAddress = "";
      return;
    }
    this.errorMessage = "";
    const q = this.queryAddress
      .split(" ")
      .join("+")
      .replace("#", "No");
    const query = `${q}+${(this.zone as any).name}`;
    this.googleQueryResults = await this.action_queryAddress(query);
    this.loadingQuery = false;
  }

  clearAddress() {
    this.queryAddress = "";
    this.googleResultAddress = "";
    this.temporalLatGoogle = 0;
    this.temporalLngGoogle = 0;
    this.positionMarker = {
      lat: 4.7,
      lng: -74.05
    };
    this.showMap = false;
    this.isManualSetup = false;
    this.nameAddress = "";
  }

  get isShowSuggestions() {
    let response = false;
    response =
      this.queryAddress.length > 0 &&
      this.showSuggestions;
    return response;
  }

  onBackButtonPress() {
    this.hasToAddAddress = false;
    this.showMap = false;
    this.isAddingNewAddress = false;
    this.clearAddress();
    this.zone = null;
  }

  get isValid() {
    let response = false;
    if (
      this.googleResultAddressExtra &&
      this.googleResultAddressExtra.length &&
      this.nameAddress &&
      this.nameAddress.length &&
      this.googleResultAddress &&
      this.googleResultAddress.length &&
      this.temporalLatGoogle !== null &&
      this.temporalLatGoogle !== undefined &&
      this.temporalLngGoogle !== null &&
      this.temporalLngGoogle !== undefined &&
      this.zone
    ) {
      response = true;
    }
    return response;
  }

  async _createAddress() {
    this.isCreatingAddress = true;
    if (this.googleResultAddressExtra) {
      this.errors = this.errors.filter((x) => x !=='address_info')
    }
    if (this.nameAddress) {
      this.errors = this.errors.filter((x) => x !== 'name')
    }

    if(!this.nameAddress || !this.googleResultAddressExtra) {
      this.showErrors = true;
      return
    }

    if (this.isValid) {
      const address = {
        address: {
          address: this.googleResultAddress,
          address_info: this.googleResultAddressExtra,
          name: this.nameAddress,
          latitude: this.temporalLatGoogle,
          longitude: this.temporalLngGoogle,
          zone_id: (this.zone as any).id
        }
      };
      try {
        await this.action_createAddress(address);
        await this.action_getUser();
        this.$emit(
          "address-selected",
          this.getUser.addresses[this.getUser.addresses.length - 1]
        );
      } catch (e) {
        this.$swal({
          title: "Dirección agregada correctamente",
          text: e
        });
      }
      this._modalClose()
    }
    this.isCreatingAddress = false;
    this._modalClose()
  }

  async deleteAddress(id) {
    this.isDeletingAddress = true;
    if(this.getCurrentAddress && this.getCurrentAddress.id == id) {
      this.CURRENT_ADDRESS(null);
    }
    try { 
      await this.action_deleteAddress(id);
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo."
      });
    }
    this.isDeletingAddress = false;
  }

  locationError(error) {
    if (error.PERMISSION_DENIED) alert('User denied the request for Geolocation.')
    else if (error.POSITION_UNAVAILABLE) alert('Location information is unavailable.')
    else if (error.TIMEOUT) alert('The request to get user location timed out.')
    else alert('An unknown error occurred.')
  }

  _modalClose() {
    this.$emit("close");
    this._setInitialForm();
    this.isAddingNewAddress = false;
    this.showMap = false;
    this.clearAddress();

    const w = window as any;
    try {
      w.Intercom("update", {
        hide_default_launcher: false
      });
    } catch (error) {
      // Do Nothing!
    }
  }

  _setInitialForm() {
    this.googleQueryResults = []
    this.showMap = false;
    this.queryAddress = ''
    this.positionMarker = { lat: 4.70, lng: -74.05 };
    this.googleResultAddress = ''
    this.googleResultAddressExtra = ''
    this.nameAddress = ''
    this.temporalLatGoogle = 0
    this.temporalLngGoogle = 0
    this.selectedAddress = {}
    this.locationExample = {}
    this.queryLoading = true
    this.hasToAddAddress = false
  }

  _selectExistingAddress(value) {
    this.CURRENT_ADDRESS(value);
    let cityZone = this.getCityZoneById(value.zone_id);
    this.CURRENT_CITY_ZONE(cityZone);
    this._modalClose();
  }

  private getCityZoneById(zoneId) {
    let res = null;
    if (this.getCity && this.getCity.zones) {
      for (let i = 0; i < this.getCity.zones.length && !res; i++) {
        if (this.getCity.zones[i].id === zoneId) {
          res = this.getCity.zones[i];
        }
      }
    }
    return res;
  }

  showAddressInitialForm() {
    this.hasToAddAddress = true;
  }

  isError(errorValue) {
    let response = false;
    if(this.errors && this.errors.length) {
      const index = this.errors.findIndex((item) => item === errorValue);
      if(index !== -1) {
        response = true;
      }
    }
    return response;
  }

  isButtonEnabled() {
    let response = false;
    if (
      this.nameAddress.length > 0 &&
      this.googleResultAddress.length > 0 &&
      this.googleResultAddressExtra.length > 0
    ) {
      response = true;
    }
    return response;
  }

  onForceAddress() {
    this.googleResultAddress = this.queryAddress;
    this.showSuggestions = false;
    this.isManualSetup = true;
    if(!this.temporalLatGoogle || !this.temporalLngGoogle) {
      this.errors.push('no_coordinates');
    }
  }

  @Watch('show')
  onShow() {
    if (this.getUser && this.getUser.addresses && this.getUser.addresses.length) {
      this.isAddingNewAddress = false;
    } else {
      this.isAddingNewAddress = true;
    }
  }

}
